import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors } from "theme";

const BaseTickBox = ({ attribute, selected, onChange, disabled, fontSize }) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            sx={{
              color: colors.primaryColor,
              "&.Mui-checked": {
                color: colors.primaryColor,
              },
            }}
          />
        }
        checked={selected}
        onChange={onChange}
        disabled={disabled}
        label={
          attribute && (
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: fontSize || 16,
                fontFamily: "Inter",
                fontWeight: "500",
                color: `${!disabled ? colors.primaryColor : "#BDBDBD"}`,
              }}
            >
              {attribute}
            </Typography>
          )
        }
        sx={{ "& .MuiSvgIcon-root": { fontSize: 28 }, width: "180px" }}
      />
    </>
  );
};
export default BaseTickBox;
